import {
  Box,
  TabList,
  Tabs,
  Button,
  useTab,
  useMultiStyleConfig,
} from '@chakra-ui/react';
import React from 'react';
import { Link, useMatch } from 'react-router-dom';

import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';

type Props = { children: React.ReactNode };

type NavTabProps = {
  children: React.ReactNode;
  end?: boolean;
  isVisible: boolean;
  to: string;
};

const NavTab = ({ children, to, end = false, isVisible }: NavTabProps) => {
  const match = useMatch({ path: to, end });
  const tabProps = useTab({});
  const styles = useMultiStyleConfig('Tabs', tabProps);
  if (!isVisible) return null;
  return (
    <Button
      __css={styles.tab}
      _active={{ fontWeight: 'bold', borderBottom: '2px' }}
      as={Link}
      isActive={!!match}
      mr={10}
      px="0"
      textAlign="center"
      alignSelf="center"
      to={to}
    >
      {children}
    </Button>
  );
};

export const StatementsTemplate = ({ children }: Props) => {
  const flags = useFeatureFlags();

  return (
    <>
      <Tabs variant="line" colorScheme="black">
        <TabList>
          <NavTab to="/statements/outstanding-ledger" isVisible>
            Outstanding Ledger
          </NavTab>

          <NavTab to="/statements/expenses-fees" isVisible>
            Expenses &amp; Fees
          </NavTab>

          <NavTab
            to="/statements/monthly-summary"
            isVisible={flags.isStatementsMonthlySummaryEnabled}
          >
            Monthly Summary
          </NavTab>
        </TabList>
      </Tabs>
      <Box mt="25px" padding="10px">
        {children}
      </Box>
    </>
  );
};
